const marketingCookieCategory = '4';

const consentManagedScripts = [
  {
    id: 'snapchat-shopify-event',
    src: 'https://intg.snapchat.com/shopify/shopify-scevent-init.js?id=a6a697fd-9d8e-40d3-8c5a-0d18d81d8602&shop=native-deodorant.myshopify.com',
  },
  {
    id: 'attentive-dtag',
    src: 'https://cdn.attn.tv/native/dtag.js?shop=native-deodorant.myshopify.com',
  },
];

function hasMarketingConsent() {
  return window.OptanonActiveGroups && window.OptanonActiveGroups.includes(marketingCookieCategory);
}

function loadConsentManagedScripts() {
  if (!hasMarketingConsent()) return;

  consentManagedScripts.forEach(function (scriptConfig) {
    if (document.querySelector('script[data-consent-script="' + scriptConfig.id + '"]')) return;

    var script = document.createElement('script');
    script.src = scriptConfig.src;
    script.type = 'text/javascript';
    script.className = 'optanon-category-' + marketingCookieCategory;
    script.dataset.consentScript = scriptConfig.id;
    script.async = false;
    document.head.appendChild(script);
  });
}

function initConsentManagedScripts() {
  if (!window.Optanon || typeof window.OptanonActiveGroups !== 'string') {
    setTimeout(initConsentManagedScripts, 100);
    return;
  }

  loadConsentManagedScripts();

  if (typeof window.Optanon.OnConsentChanged === 'function') {
    window.Optanon.OnConsentChanged(loadConsentManagedScripts);
  }
}

document.addEventListener('DOMContentLoaded', initConsentManagedScripts);
